import { useState, useEffect } from "react";

import { useLocation, Link, useNavigate } from "react-router-dom";

import PropTypes from "prop-types";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Icon from "@mui/material/Icon";

import MDBox from "components/MDBox";
import MDInput from "components/MDInput";

import Breadcrumbs from "examples/Breadcrumbs";
import NotificationItem from "examples/Items/NotificationItem";

import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarMobileMenu,
} from "examples/Navbars/DashboardNavbar/styles";
import Swal from "sweetalert2";

import {
  useMaterialUIController,
  setTransparentNavbar,
  setMiniSidenav,
  setOpenConfigurator,
} from "context";
import { MenuItem, Typography, useTheme } from "@mui/material";
import Card from "@mui/material/Card";

function DashboardNavbar({ absolute, light, isMini }) {
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar, openConfigurator, darkMode } = controller;
  const [openMenu, setOpenMenu] = useState(false);
  const route = useLocation().pathname.split("/").slice(1);

  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  const navigate = useNavigate();

  const [username, setUsername] = useState("");

  useEffect(() => {
    const name = sessionStorage.getItem("custName");
    if (name) {
      setUsername(name);
    }
  }, []);

  useEffect(() => {
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    function handleTransparentNavbar() {
      setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
    }

    window.addEventListener("scroll", handleTransparentNavbar);

    handleTransparentNavbar();

    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);
  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleCloseMenu = () => setOpenMenu(false);

  const handleLogout = () => {
    Swal.fire({
      title: "Log Out",
      text: "Are you sure you want to logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#ffc107",
      confirmButtonText: "Logout",
      cancelButtonText: "Cancel",
      allowOutsideClick: false,
      allowEscapeKey: false,
      backdrop: true,
    }).then((result) => {
      if (result.isConfirmed) {
        sessionStorage.clear();
        localStorage.clear();
        navigate("/Customer/login");
      }
    });
  };

  // Render the notifications menu
  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 1, width: "max-content" }}
    >
      <NotificationItem
        icon={<Icon>logout</Icon>}
        title="Logout"
        onClick={() => {
          handleCloseMenu();
          handleLogout();
        }}
      />
    </Menu>
  );

  // Styles for the navbar icons
  const iconsStyle = ({ palette: { dark, white, text }, functions: { rgba } }) => ({
    color: () => {
      let colorValue = light || darkMode ? white.main : dark.main;

      if (transparentNavbar && !light) {
        colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
      }

      return colorValue;
    },
  });

  return (
    <Card
      elevation={3}
      sx={(theme) => ({
        position: "sticky",
        top: 0,
        zIndex: theme.zIndex.appBar,
        borderRadius: 0,
      })}
    >
      <AppBar
        position="static"
        color="inherit"
        elevation={0}
        sx={(theme) =>
          navbar(theme, {
            transparentNavbar: false,
            absolute: false,
            light,
            darkMode,
          })
        }
      >
        <Toolbar sx={(theme) => navbarContainer(theme)}>
          <MDBox color="inherit" mb={{ xs: 1, md: 0 }} sx={(theme) => navbarRow(theme, { isMini })}>
            <Breadcrumbs icon="home" title={route[route.length - 1]} route={route} light={light} />
          </MDBox>
          {isMini ? null : (
            <MDBox sx={(theme) => navbarRow(theme, { isMini })}>
              <MDBox color={light ? "white" : "inherit"}>
                {/* <Link to="/authentication/sign-in/basic">
                <IconButton sx={navbarIconButton} size="small" disableRipple>
                  <Icon sx={iconsStyle}>account_circle</Icon>
                </IconButton>
              </Link> */}
                {/* <IconButton
                  size="small"
                  disableRipple
                  color="inherit"
                  sx={{
                    ...navbarIconButton,
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                  }}
                  onClick={() => {
                    renderMenu();
                  }}
                >
                  <Icon sx={iconsStyle} fontSize="medium">
                    account_circle
                  </Icon>

                  <Typography
                    sx={{
                      fontSize: 17,
                      color: "#0000cc",
                      fontWeight: "medium",
                      mt: 0.8,
                      lineHeight: 1.2,
                    }}
                  >
                    {username || ""}
                  </Typography>
                </IconButton> */}

                <IconButton
                  size="small"
                  disableRipple
                  color="inherit"
                  sx={{
                    ...navbarIconButton,
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                  }}
                  onClick={(event) => {
                    setOpenMenu(event.currentTarget);
                  }}
                >
                  <Icon sx={iconsStyle} fontSize="medium">
                    account_circle
                  </Icon>
                  <Typography
                    sx={{
                      fontSize: 17,
                      color: "#0000cc",
                      fontWeight: "medium",
                      mt: 0.8,
                      lineHeight: 1.2,
                    }}
                  >
                    {username || ""}
                  </Typography>
                </IconButton>

                <IconButton
                  size="small"
                  disableRipple
                  color="inherit"
                  sx={navbarMobileMenu}
                  onClick={handleMiniSidenav}
                >
                  <Icon sx={iconsStyle} fontSize="medium">
                    {miniSidenav ? "menu_open" : "menu"}
                  </Icon>
                </IconButton>
                {/* <IconButton
                size="small"
                disableRipple
                color="inherit"
                sx={navbarIconButton}
                onClick={handleConfiguratorOpen}
              >
                <Icon sx={iconsStyle}>settings</Icon>
              </IconButton> */}
                {/* <IconButton
                size="small"
                disableRipple
                color="inherit"
                sx={navbarIconButton}
                aria-controls="notification-menu"
                aria-haspopup="true"
                variant="contained"
                onClick={handleOpenMenu}
              >
                <Icon sx={iconsStyle}>notifications</Icon>
              </IconButton> */}
                {renderMenu()}
              </MDBox>
            </MDBox>
          )}
        </Toolbar>
      </AppBar>
    </Card>
  );
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
